import { FieldNamesMarkedBoolean } from 'react-hook-form';
import { IGlobalItem } from 'src/components/CreateGlobalItemWizard/types';

/**
 * Get an array of dirty fields
 * @param  {Object} object that contains keys of IGlobalItem
 * marked as true if they have been modified, i.e. 'dirty fields'
 * @return {Object[]} Array of 'dirty fields' keys of IGlobalItem
 */

export type TGlobalItemKey = keyof IGlobalItem;

export const getDirtyFields = (
  dirtyFields: Partial<Readonly<FieldNamesMarkedBoolean<IGlobalItem>>>,
): TGlobalItemKey[] =>
  Object.entries(dirtyFields).reduce(
    (acc: TGlobalItemKey[], [key, value]: [TGlobalItemKey, boolean]) => (value ? [...acc, key] : acc),
    [],
  );
